import { domain } from 'modules/data';
import { GetCompanies } from 'shared/data/webApp/v1';

export const checkIsTrialActive = (data?: GetCompanies<true>['response']) => {
    return data?.companies?.[0]?.allFeaturesTrialStatus === domain.AllFeaturesTrialStatus.Active;
};
